import { useAppDispatch, useAppSelector } from "@/config/store";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { activateAction, reset } from "./activate.reducer";

const successAlert = (
  <div className="rounded-md border border-green-200 bg-green-50 p-4 text-green-800 dark:border-green-800 dark:bg-green-900/30 dark:text-green-200">
    <strong>Your user account has been activated.</strong> Please{" "}
    <Link to="/login" className="font-medium underline">
      sign in
    </Link>
    .
  </div>
);

const failureAlert = (
  <div className="rounded-md border border-red-200 bg-red-50 p-4 text-red-800 dark:border-red-800 dark:bg-red-900/30 dark:text-red-200">
    <strong>Your user could not be activated.</strong> Please use the registration form to sign up.
  </div>
);

export const ActivatePage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  
  useEffect(() => {
    const key = searchParams.get("key") || "";
    dispatch(activateAction(key));
    return () => {
      dispatch(reset());
    };
  }, []);

  const { activationSuccess, activationFailure } = useAppSelector(
    (state) => state.activate
  );

  return (
    <div>
      <h1 className="text-xl font-semibold">Activation</h1>
      {activationSuccess ? successAlert : undefined}
      {activationFailure ? failureAlert : undefined}
    </div>
  );
};

export default ActivatePage;
